import * as HistoryBetActions from 'actions/HistoryBet';
import * as StorageActions from 'actions/Storage';

import * as CouponState from 'constants/CouponState';

export default function stateReducer(state, action) {
    switch (action.type) {
        case StorageActions.LOAD_STORAGE:
            const couponState = action.data.couponState;
            if (couponState !== undefined && couponState !== null) {
                return couponState;
            }
            break;

        case HistoryBetActions.REQUEST_BET_TYPES:
            return CouponState.DISABLED;

        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
            return CouponState.ENABLED;

        case HistoryBetActions.FAILURE_REQUEST_BET_TYPES:
            return CouponState.ENABLED;
    }

    return state;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/stateReducer.js